export default "__VITE_ASSET__U_j6f27___"